<template>
  <a-table v-bind="tbConfig"
           :columns="_columns"
           :dataSource="data"
           :loading="loading"
           @change="handleTableChange"
           ref="table"
           :customRow="customRow">
    <slot></slot>
    <template v-for="customSlot in customSlots" :slot="customSlot" slot-scope="text, record, index">
      <slot :name="customSlot" v-bind:text="text" v-bind:record="record" v-bind:index="index"></slot>
    </template>
    <div slot="filterDropdown"
         slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
         style="padding: 8px">
      <a-input v-ant-ref="c => searchInput = c"
               :placeholder="`Buscar ${column.title}`"
               :value="selectedKeys[0]"
               @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
               @pressEnter="() => handleSearch(selectedKeys, confirm)"
               style="width: 188px; margin-bottom: 8px; display: block;"/>
      <a-button type="primary"
                @click="() => handleSearch(selectedKeys, confirm)"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px">
        Buscar
      </a-button>
      <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">
        Reset
      </a-button>
    </div>
    <a-icon slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"/>
    <template slot="defaultDtRender" slot-scope="text">
            <span v-if="searchText && text !== null && text !== undefined">
                <template
                  v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                    <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                          :key="i"
                          class="highlight">
                        {{fragment && fragment.trim()}}
                    </mark>
                    <template v-else>
                        {{fragment && fragment.trim()}}
                    </template>
                </template>
            </span>
      <template v-else>
        {{text}}
      </template>
    </template>
    <template slot="action" slot-scope="record">
      <a-button-group>
        <a-button v-for="action in actions.actions" v-bind="action.props"
                  @click="() => {action.fnLoading && action.fnLoading(record); handleCustomAction(action, record)}"
                  v-if="action.fnVisible ? action.fnVisible(record) : true"
                  :loading="action.fnLoading ? action.fnLoading(record) : false">
          {{action.text}}
        </a-button>
      </a-button-group>
    </template>
    <template slot="hooverableAction" slot-scope="record">
      &nbsp;
      <a-popover title="" trigger="hover" v-for="action in actions.actions"
                 v-if="action.fnVisible ? action.fnVisible(record) : true">
        <template slot="content">
          {{action.text}}
        </template>
        <a-button v-bind="action.props"
                  @click="() => {action.fnLoading && action.fnLoading(record); handleCustomAction(action, record)}"
                  :loading="action.fnLoading ? action.fnLoading(record) : false"></a-button>
      </a-popover>
    </template>
    <div slot="dateBetweenFilter"
         slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
         style="padding: 5px; border:1px solid #e0e0e0">
      <span>Buscar {{column.title}}</span>

      <a-range-picker :value="dateFilterToMoment(selectedKeys)"
                      @change="dates => dateFilterChanged(dates, setSelectedKeys)"
                      style="margin-bottom: 8px; display: block;"
      />
      <a-button type="primary"
                @click="() => handleSearch(selectedKeys, confirm, 'date')"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px">
        Buscar
      </a-button>
      <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">
        Reset
      </a-button>
    </div>
    <div slot="moneyRender" slot-scope="text" style="text-align: right;">
            <span v-if="searchText && text !== null && text !== undefined">
                <template
                  v-for="(fragment, i) in format(parseFloat(text)).split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                    <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                          :key="i"
                          class="highlight">
                        {{fragment && fragment.trim()}}
                    </mark>
                    <template v-else>
                        {{fragment && fragment.trim()}}
                    </template>
                </template>
            </span>
      <template v-else>
        {{format(parseFloat(text))}}
      </template>
    </div>
  </a-table>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import DateUtils from '@/util/DateUtils'
  import NumberUtils from '@/util/NumberUtils'

  export default {
    /**
     * actions debe tener este formato:
     * {
     *      datos de la columna normal ...
     *      actions: [
     *          { name: xxxx, text: xxxx, icon: xxxx, permisos: []  }
     *      ]
     *      Permisos es un vector de permisos si el usuario tiene alguno de los permisos se muestra el boton
     * }
     * customSlots: debe ser un vector de string
     * fnSelectionDisabled: debe ser una función que recibe la fila y retorna "True" si esa fila puede ser seleccionada
     */
    /*
     * TODO Verificar el impacto y uso de customSlots en los componentes TipoTabla y TipoForm.
     */
    props: ['columns', 'endpoint', 'tableConfig', 'allowSelect', 'selectType', 'selectedRowKeys', 'selectedRows', 'actions', 'requestData', 'customSlots', 'fnSelectionDisabled'],
    data () {
      return {
        actionsLoaded: false,
        data: [],
        loading: false,
        tbConfig: {
          scroll: {x: 'max-content'},
          bordered: true,
          size: 'small',
          pagination: {
            pageSize: 5,
            current: 1,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40'],
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
          }
        },
        lastSearch: {
          per_page: 5,
          page: 1
        },
        /* slots */
        searchInput: null,
        searchText: '',
        selected: [],
        rowKey: '',
        _columns: []
      }
    },
    beforeMount () {
      this._columns = [...this.columns]
      if (this.allowSelect === true) {
        this.tbConfig.rowSelection = {
          selectedRowKeys: this.selectedRowKeys || [],
          onChange: this.handleSelectionChange,
          getCheckboxProps: record => ({
            props: {
              disabled: this.fnSelectionDisabled && this.fnSelectionDisabled(record)
            }
          }),
          type: this.selectType === 'checkbox' ? 'checkbox' : 'radio',
          columnWidth: 38,
          onSelectAll: (selected, selectedRows, changeRows) => {
            this.$emit('selectAll', selected)
          }
        }
      }
      this.tbConfig = {...this.tbConfig, ...this.tableConfig}
      this.lastSearch = {
        per_page: this.tbConfig.pagination.pageSize,
        page: this.tbConfig.pagination.current
      }
      let defSlots = {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        customRender: 'defaultDtRender'
      }
      this._columns.map((col) => {
        col.scopedSlots = {...defSlots, ...col.scopedSlots}
        col.onFilterDropdownVisibleChange = visible => {
          if (visible && this.searchInput) {
            setTimeout(() => { this.searchInput.focus() }, 0)
          }
        }
      })
      if (!JsUtils.isEmpty(this.actions) && !this.actionsLoaded) {
        this._columns.push(this.actions)
        this.actionsLoaded = true
      }
    },
    mounted () {
      this.rowKey = this.tbConfig.rowKey
      this.http = new HttpUtil()
      this.loadData()
    },
    methods: {
      handleTableChange (pagination, filters, sorter) {
        const pager = {...this.tbConfig.pagination}
        pager.current = pagination.current
        this.tbConfig.pagination = pagination
        this.setConfig()
        let params = {
          per_page: pagination.pageSize,
          page: pagination.current,
          sortField: sorter.field,
          sortOrder: sorter.order,
          ...filters
        }
        this.loadData(params)
        this.$emit('params', params)
      },
      loadData (params) {
        if (JsUtils.isEmpty(params)) {
          params = this.lastSearch
        } else {
          this.lastSearch = params
        }
        if (!JsUtils.isEmpty(this.requestData)) {
          params = {...this.requestData, ...params}
        }
        this.loading = true
        this.clearSelection()

        this.http.getInstance().post(this.endpoint + '/datatable', params)
          .then((response) => {
            const pagination = {...this.tbConfig.pagination}
            pagination.total = response.data.total
            this.loading = false
            this.data = response.data.data
            this.tbConfig.pagination = pagination
            this.setConfig()
          })
          .catch((error) => {
            this.$notification['error']({
              message: 'Error.',
              description: 'No fue posible consultar la información.'
            })
            this.data = []
          })
          .then(() => {
            this.loading = false
          })
      },
      handleSearch (selectedKeys, confirm, type = 'text') {
        confirm()
        if (type === 'text') {
          this.searchText = selectedKeys[0]
        }
      },
      handleReset (clearFilters) {
        clearFilters()
        this.searchText = ''
      },
      setConfig () {
        this.tbConfig = {...this.tbConfig}
      },
      handleSelectionChange (selectedRowKeys, selectedRows) {
        this.tbConfig.rowSelection.selectedRowKeys = selectedRowKeys
        this.tbConfig.rowSelection.selectedRows = selectedRows
        this.$emit('update:selectedRowKeys', selectedRowKeys)
        this.$emit('update:selectedRows', selectedRows)
        this.$nextTick(() => {
          this.setConfig()
        })
      },
      validateUndefSelection () {
        if (!this.allowSelect) return
        if (!this.tbConfig.rowSelection.selectedRowKeys) {
          this.tbConfig.rowSelection.selectedRowKeys = []
        }
        if (!this.tbConfig.rowSelection.selectedRows) {
          this.tbConfig.rowSelection.selectedRows = []
        }
      },
      clearSelection () {
        if (!this.allowSelect) return
        this.validateUndefSelection()
        this.tbConfig.rowSelection.selectedRowKeys = []
        this.tbConfig.rowSelection.selectedRows = []
        this.$emit('update:selectedRowKeys', [])
        this.$emit('update:selectedRows', [])
      },
      handleCheckboxSelection (record) {
        this.validateUndefSelection()
        if (this.tbConfig.rowSelection.selectedRowKeys.includes(record[this.rowKey])) {
          this.tbConfig.rowSelection.selectedRowKeys = this.tbConfig.rowSelection.selectedRowKeys.filter((value) => {
            return value !== record[this.rowKey]
          })
          this.tbConfig.rowSelection.selectedRows = this.tbConfig.rowSelection.selectedRows.filter((value) => {
            return value[this.rowKey] !== record[this.rowKey]
          })
        } else {
          this.tbConfig.rowSelection.selectedRowKeys.push(record[this.rowKey])
          this.tbConfig.rowSelection.selectedRows.push(record)
        }
      },
      handleRadioSelection (record) {
        this.validateUndefSelection()
        if (!this.tbConfig.rowSelection.selectedRowKeys.includes(record[this.rowKey])) {
          this.tbConfig.rowSelection.selectedRowKeys = [record[this.rowKey]]
          this.tbConfig.rowSelection.selectedRows = [record]
        }
      },
      customRow (record) {
        if (this.allowSelect === true) {
          return {
            on: {
              click: (e) => {
                if (!JsUtils.isEmpty(this.fnSelectionDisabled)) {
                  if (this.fnSelectionDisabled(record)) {
                    return
                  }
                }
                if (this.selectType === 'checkbox') {
                  this.handleCheckboxSelection(record)
                } else {
                  this.handleRadioSelection(record)
                }
                this.handleSelectionChange(this.tbConfig.rowSelection.selectedRowKeys, this.tbConfig.rowSelection.selectedRows)
              }
            }
          }
        }
        return {}
      },
      handleCustomAction (action, record) {
        this.$emit('action', {
          action: action.name,
          _action: action,
          record: record
        })
      },
      dateFilterChanged (dates, setSelectedKeys) {
        if (dates) {
          setSelectedKeys([DateUtils.forBackEnd(dates[0].startOf('date')), DateUtils.forBackEnd(dates[1].endOf('date'))])
        } else {
          setSelectedKeys([])
        }
      },
      dateFilterToMoment (selectedKeys) {
        if (!JsUtils.isEmpty(selectedKeys)) {
          return [moment(selectedKeys[0]), moment(selectedKeys[1])]
        }
        return []
      },
      format (value) {
        return NumberUtils.formatMoney(value, 0)
      }
    },
    watch: {
      requestData () {
        this.$nextTick(() => {
          this.loadData()
        })
      }
    }
  }
</script>
<style>
  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0;
  }

  /*.ant-table td { white-space: nowrap; }*/
</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/datatable.vue